import styled, { CSSObject } from '@emotion/styled'
import { metricsPN } from '@news-mono/design-tokens'
import { linearGradient } from 'polished'
import { colors } from '../../__styling/settings/colors'
import { zIndex } from '../../__styling/settings/z-index'
import { breakpoint, calcRem } from '../../__styling/style-functions'
import { StyledPNArticleVideo } from '../../nextgen-news/perthnow/publication/PNArticleVideo/PNArticleVideo.styled'
const { spacing } = metricsPN

/** Applied to a child will make it span the full-width. */
const spanArticleScreen: CSSObject = {
    gridColumn: '1 / -1',
}
export const CONTENT_START_LINE = 'content-start'
export const CONTENT_END_LINE = 'content-end'
/** Applied to a child will make it span only the content columns. */
const spanArticleContent: CSSObject = {
    gridColumn: 'content',
}

interface StyledBlockContentProps {
    hasRegistrationWall: boolean
    isPerthNowNGN: boolean
}

// This is needed to fix an IE10 issue with overflowing content.
// TODO: Remove when we upgrade to React16 and remove extra uncessary wrapping div
export const StyledBlockContent = styled('div')<StyledBlockContentProps>(
    {
        position: 'relative',
        width: '100%',
    },
    ({ hasRegistrationWall }) =>
        hasRegistrationWall && {
            '&:before': {
                content: `''`,
                position: 'absolute',
                height: '100%',
                width: '100%',
                zIndex: zIndex.common.regWall.fade,

                ...linearGradient({
                    // Need to use rgba(255, 255, 255, 0) for the linear gradient otherwise it won't look good in Safari
                    // https://stackoverflow.com/questions/38391457/linear-gradient-to-transparent-bug-in-latest-safari
                    colorStops: [
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0.8)',
                        colors.white,
                    ],
                    fallback: 'transparent',
                    toDirection: '180deg',
                }),
            },
        },
    ({ isPerthNowNGN }) =>
        isPerthNowNGN && {
            display: 'grid',
            flexDirection: 'column',
            gridTemplateColumns: `[${CONTENT_START_LINE}] 1fr [${CONTENT_END_LINE}]`,
            gridAutoRows: 'min-content',

            rowGap: calcRem(24),

            [breakpoint('sm')]: {
                rowGap: calcRem(32),
            },

            [breakpoint('lg')]: {
                rowGap: calcRem(24),
            },

            [`& > ${StyledPNArticleVideo}`]: spanArticleScreen,

            // Have all children only span the content columns by default.
            '& > *': spanArticleContent,
        },
)
StyledBlockContent.displayName = 'StyledBlockContent'

export const TwinImageWrapper = styled('div')({
    clear: 'both',

    [breakpoint('sm')]: {
        lineHeight: '0px',

        '&::after': {
            content: `''`,
            clear: 'both',
            width: '100%',
            display: 'inline-block',
        },
    },
})
TwinImageWrapper.displayName = 'TwinImageWrapper'

export const PNTwinImageWrapper = styled('div')({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    gap: calcRem(spacing['2XS']),
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',

    '&>figure': {
        padding: 0,
        margin: 0,
        // The image width is 397px as per the design, but the gap between images is 8px, so we need to reduce the width to 393px.
        maxWidth: calcRem(393),
        width: '100%',
    },
})
